module.exports = function reducer_Online(state = {}) {
    return state;
};
